module.exports = __webpack_public_path__ + "static/media/merlyn-vyapar.5ee0ed96.jpeg";